import { DomainEvent } from './DomainEvent'

export class PageCreated extends DomainEvent {
  readonly eventType = 'page.created' as const
  constructor(
    aggregateId: string,
    public readonly siteId: string,
    public readonly slug: string,
    public readonly isHome: boolean,
  ) { super(aggregateId) }
}

export class PagePublished extends DomainEvent {
  readonly eventType = 'page.published' as const
  constructor(aggregateId: string, public readonly siteId: string) { super(aggregateId) }
}

export class PageUnpublished extends DomainEvent {
  readonly eventType = 'page.unpublished' as const
  constructor(aggregateId: string, public readonly siteId: string) { super(aggregateId) }
}
